import React, { Component } from "react";
import { Progress } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareAlt, faCircle } from "@fortawesome/free-solid-svg-icons";

class AgorasDistribution extends Component {
  render() {
    return (
      <div className="col-lg-4 p-3 col-md-6 home-market-stat-col">
        <div
          className="market-column h-100 p-3"
          style={{
            background: "var(--cardBg)",
            border: "var(--card-border)"
          }}
        >
          <div className="market-inner-col d-flex justify-content-between mb-3">
            <span className="badge badge-warning market-bedge">
              agoras distribution
            </span>
            <img
              className="img-fluid"
              src={require("../../../assets/icons/share-icon.svg")}
              alt="share"
            />
          </div>
          <h3
            className="market-col-heading text-left"
            style={{ color: "var(--h3Color)" }}
          >
            <span className="first-text">Agoras </span>
            <span className="">
              <img
                className="img-fluid pl-1 pr-1"
                src={require("../../../assets/icons/agoras-icon.svg")}
                alt="Agoras"
              />
            </span>
            <span className="market-agrs"> AGRS</span>
          </h3>

          <div className="market-inner-col d-flex justify-content-between mt-3 mb-3 sector-category">
            <span
              className="currency-row"
              style={{ color: "var(--pDescColor)" }}
            >
              Sector : <span className="currency-text">Stats</span>
            </span>
            <span
              className="currency-row"
              style={{ color: "var(--pDescColor)" }}
            >
              Category : <span className="currency-text">Currency</span>
            </span>
          </div>

          <div className="stats-div mt-4">
            <p style={{ color: "var(--pDescColor)" }}>
              Wallets with more than:
            </p>
            <br />
            <Progress multi className="wallets-progress">
              <Progress bar className="wallet-1-bar" value="25" />
              <Progress bar className="wallet-2-bar" value="30" />
              <Progress bar className="wallet-3-bar" value="25" />
              <Progress bar className="wallet-4-bar" value="20" />
            </Progress>

            <div className="row">
              <div className="col-6">
                <ul className="wallet-stats">
                  <li style={{ color: "var(--listColor)" }}>
                    <FontAwesomeIcon
                      icon={faCircle}
                      className="faCircle icon-1"
                    />{" "}
                    1% <span>(17)</span>
                  </li>
                  <li className="" style={{ color: "var(--listColor)" }}>
                    <FontAwesomeIcon
                      icon={faCircle}
                      className="faCircle icon-2"
                    />{" "}
                    0.1%<span>(110)</span>
                  </li>
                </ul>
              </div>
              <div className="col-6">
                <ul className="wallet-stats">
                  <li style={{ color: "var(--listColor)" }}>
                    <FontAwesomeIcon
                      icon={faCircle}
                      className="faCircle icon-3"
                    />{" "}
                    0.01% <span>(360)</span>
                  </li>
                  <li className="" style={{ color: "var(--listColor)" }}>
                    <FontAwesomeIcon
                      icon={faCircle}
                      className="faCircle icon-4"
                    />{" "}
                    0.001%<span>(875)</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <p
            className="text-left mt-4"
            style={{
              color: "var(--pDescColor)",
              transition: "color 0.2s ease-out 0s, background 0.2s ease-out 0s"
            }}
          >
            Non-Empty Wallets: 1517
          </p>
          <p
            className="text-left"
            style={{
              color: "var(--pDescColor)",
              transition: "color 0.2s ease-out 0s, background 0.2s ease-out 0s"
            }}
          >
            In Circulation: 31.2 M agrs
          </p>
          <p
            className="text-left"
            style={{
              color: "var(--pDescColor)",
              transition: "color 0.2s ease-out 0s, background 0.2s ease-out 0s"
            }}
          >
            Total Supply: 42 M agrs
          </p>
        </div>
      </div>
    );
  }
}

export default AgorasDistribution;
